export const TestIds = {
  section: 'section-container',
} as const;

export const corvidName = '$w.Section';
